import React, { useState } from "react";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Spinner,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { DASHBOARD_TYPE } from "src/constant/common";
import TooltipWrapper from "src/components/Common/TooltipWrapper";

const SeriesExpectedCasualtyDashboard = ({
  handleClickFailureImpact,
  handleClickSummary,
  id,
  isLoading,
  isShow = true,
  serieData,
}) => {
  const { t } = useTranslation("flight-simulator");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const isDashboardReady = (type) => {
    return !!serieData.simulator_dashboards.filter((item) => item.dashboard_type === type)?.[0]?.dashboard_url;
  };

  return isShow ? (
    isLoading ? (
      <Spinner size="sm" color="secondary" />
    ) : (
      <TooltipWrapper tooltipText={t("list.table.dashboard")} id={`dashboard-serie-${id}`}>
        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className="align-self-center">
          <DropdownToggle data-toggle="dropdown" tag="button" className="border-0 bg-transparent">
            <i className={`bi bi-speedometer2 ${serieData.simulator_dashboards.length > 1 ? "text-success" : "text-dark"} f-s-20`} />
          </DropdownToggle>

          <DropdownMenu className="topbar-dropdown-menu profile-dropdown-items" container=".navbar">
            <div onClick={toggleDropdown}>
              <div
                role="button"
                className={`dropdown-item ${isDashboardReady(DASHBOARD_TYPE.EXPECTED_CASUALTY_FAILURE_IMPACT_6DOF) ? "text-success" : "text-dark"}`}
                onClick={handleClickFailureImpact}
              >
                <span>{t("list.table.expected_casualty_failure_impact_dashboard")}</span>
              </div>
              <div
                role="button"
                className={`dropdown-item ${isDashboardReady(DASHBOARD_TYPE.EXPECTED_CASUALTY_SUMMARY_6DOF) ? "text-success" : "text-dark"}`}
                onClick={handleClickSummary}
              >
                <span>{t("list.table.expected_casualty_summary_dashboard")}</span>
              </div>
            </div>
          </DropdownMenu>
        </Dropdown>
      </TooltipWrapper>
    )
  ) : null;
};

export default SeriesExpectedCasualtyDashboard;
